export const endpoints = {
  user: {
    login: "app/auth/sign-in",
    getme: "app/auth/get-me",
  },
};
